import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MKTypography from "components/MKTypography";
import logoCT from "assets/images/macoce-logo-light.png";

const date = new Date().getFullYear();

export default function getFooterRoutes(messages) {
  return {
    brand: {
      name: "Macoce",
      image: logoCT,
      route: "/",
    },
    socials: [
      {
        icon: <FacebookIcon />,
        link: "https://www.facebook.com/CreativeTim/",
      },
      {
        icon: <TwitterIcon />,
        link: "https://twitter.com/creativetim",
      },
      {
        icon: <GitHubIcon />,
        link: "https://github.com/creativetimofficial",
      },
      {
        icon: <YouTubeIcon />,
        link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
      },
    ],
    menus: messages.footer.menus,
    copyright: (
      <MKTypography variant="button" fontWeight="regular">
        {messages.footer.copyrightLead} &copy; {date} Macoce.com {messages.footer.by}{" "}
        <MKTypography
          component="a"
          href="https://www.linkedin.com/in/antoniosalcido/"
          target="_blank"
          rel="noreferrer"
          variant="button"
          fontWeight="regular"
        >
          UltharKey
        </MKTypography>
        .
      </MKTypography>
    ),
  };
}
